/**
 * 像素转rem
 * @param {number} $px 像素大小
 * @returns {number} rem大小
 */

export const px2rem = ($px: number) => {
  return $px + 'px'
}
